import { api } from './client';

export interface PendenciaItem {
  tipo: 'nfe' | 'cte' | 'cte_os' | 'mdfe' | 'dfe' | string;
  id: number;
  numero?: number | string | null;
  serie?: number | string | null;
  modelo?: string | null;
  chave?: string | null;
  ambiente?: string | null;
  status?: string | null;
  c_stat_sefaz?: string | null;
  x_motivo_sefaz?: string | null;
  categoria: string;
  severidade: 'alta' | 'media' | 'baixa' | string;
  mensagem: string;
  data?: string | null;
  url: string;
}

export interface PendenciasResumo {
  total: number;
  alta: number;
  media: number;
  baixa: number;
  rejeicoes: number;
  rascunhos: number;
  dfe: number;
  xml_pdf: number;
  certificados?: number;
}

export interface PendenciasResponse {
  emitente_id?: number | null;
  resumo: PendenciasResumo;
  itens: PendenciaItem[];
}

export interface RejeicaoItem {
  origem: 'documento' | 'evento' | string;
  tipo: string;
  id: number;
  evento_id?: number;
  tipo_evento?: string;
  nome_evento?: string;
  sequencial?: number;
  numero?: number | string | null;
  serie?: number | string | null;
  modelo?: string | null;
  chave?: string | null;
  ambiente?: string | null;
  status?: string | null;
  c_stat_sefaz?: string | null;
  x_motivo_sefaz?: string | null;
  data?: string | null;
  url: string;
}

export interface RejeicoesResponse {
  emitente_id?: number | null;
  resumo: {
    total: number;
    por_cstat: Record<string, number>;
    por_tipo: Record<string, number>;
  };
  itens: RejeicaoItem[];
}

export async function getPendencias(emitenteId?: number | null): Promise<PendenciasResponse> {
  const { data } = await api.get<PendenciasResponse>('/documentos/pendencias', {
    params: { emitente_id: emitenteId || undefined },
  });
  return data;
}

export async function getRejeicoes(emitenteId?: number | null): Promise<RejeicoesResponse> {
  const { data } = await api.get<RejeicoesResponse>('/documentos/rejeicoes', {
    params: { emitente_id: emitenteId || undefined },
  });
  return data;
}
